export default __webpack_public_path__ + "static/media/la_capelle11.19a34319.jpg";